import { useMemo } from 'react'
import { useGlobalStore } from '@highlight/ipc/react'

export type TranscriptionMethod = 'local' | 'cloud'
export type AudioNoteStorageMethod = 'local' | 'cloud'

export const useAudioNoteSettings = () => {
  const [audioNoteTranscriptionMethod, setAudioNoteTranscriptionMethod] = useGlobalStore<TranscriptionMethod>(
    'settings',
    'audio-notes.transcription-method',
    'cloud',
  )
  const [audioNoteStorageMethod, setAudioNoteStorageMethod] = useGlobalStore<AudioNoteStorageMethod>(
    'settings',
    'audio-notes.storage-method',
    'cloud',
  )

  return useMemo(() => {
    return {
      audioNoteTranscriptionMethod,
      audioNoteStorageMethod,
      setAudioNoteTranscriptionMethod,
      setAudioNoteStorageMethod,
      isUsingLocalTranscription: audioNoteTranscriptionMethod === 'local',
      isUsingLocalStorage: audioNoteStorageMethod === 'local',
    }
  }, [audioNoteTranscriptionMethod, audioNoteStorageMethod, setAudioNoteTranscriptionMethod, setAudioNoteStorageMethod])
}
